import { render, staticRenderFns } from "./BibleStudy.vue?vue&type=template&id=1ef5a3d6&"
import script from "./BibleStudy.vue?vue&type=script&lang=js&"
export * from "./BibleStudy.vue?vue&type=script&lang=js&"
import style0 from "./BibleStudy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports